import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { ButtonProps, ButtonType } from '../Button/ButtonWidget';
import { DivAttrs } from '../../utils/HtmlAttrs';
import { ContentClass, InlineAlert, InlineAlertBaseProps, InlineAlertType, MessageClass } from './InlineAlertBase';

export { InlineAlertType };

export interface InlineAlertProps extends Pick<InlineAlertBaseProps, 'testId' | 'type'> {
  /**
   * ButtonWidget to appear in the alert, if applicable.
   * Its `buttonType` prop will be overridden to `ButtonType.Outline`.
   */
  button?: React.ReactElement<ButtonProps>;
}

const VerticalPadding: number = 16;
const ButtonContainerClass: string = 'buttonContainer';

export const AlertStyleName: string = TypeStyle.style({
  paddingTop: VerticalPadding,
  $nest: {
    [`& .${ContentClass}`]: {
      flexWrap: 'wrap',
      // We use offsetting margin + padding here accommodate wrapping behavior
      // This allows the button to wrap underneath the text, without causing extra height when not wrapped
      marginBottom: -VerticalPadding,
      minHeight: 40,
      paddingBottom: VerticalPadding,
    },
    [`& .${MessageClass}`]: {
      margin: `3px 16px ${VerticalPadding}px 8px`,
    },
    [`& .${ButtonContainerClass}`]: {
      margin: `0px 16px ${VerticalPadding}px 8px`,
    },
  }
});

const InlineAlertButton = (button: React.ReactElement<ButtonProps>) =>
  <div className={ButtonContainerClass}>
    {React.cloneElement<ButtonProps>(button, {
      buttonType: ButtonType.Outline,
    })}
  </div>;

export const InlineAlertWidget = React.forwardRef<HTMLDivElement, InlineAlertProps & DivAttrs>((props, ref) => {
  const { button, className, ...restProps } = props;
  return (
    <InlineAlert
      {...restProps}
      className={TypeStyle.classes(className, AlertStyleName)}
      interactiveElement={button && InlineAlertButton(button)}
      ref={ref}
    />
  );
});
InlineAlertWidget.displayName = 'InlineAlertWidget';
